// @flow

/*::
import type { Request, Response } from './types'

const assertErrorResponse = (r: Response): {
  id: string,
  message: string,
  meta: {
    error?: string,
    status?: number,
    statusText?: string,
    type: $PropertyType<Request, "type">,
    url?: string,
  },
  type: "error",
} => {
  if (r.type === 'error') return r
  throw Error()
}
*/

type ErrorResponse = $Call<typeof assertErrorResponse, Response>
type Meta = $Call<<T>({ +type: 'error', +meta: T, ... } | any) => T, Response>

// Supports all package errors and provides a convenient meta property for
// logging errors with Bugsnag for debugg.
export class AuthError extends Error {
  name: string = 'AuthError'
  meta: Meta

  constructor(response: ErrorResponse) {
    super(response.message)

    this.meta = response.meta
  }
}

// Unexpected and programmer errors.
export class UnexpectedError extends Error {
  name: string = 'UnexpectedError'
  meta: Meta

  constructor(message: string, meta?: Meta = {}) {
    super(message)

    this.meta = meta ?? { error: this.toString() }
  }
}
